import { render } from "./DataTypesSection.vue?vue&type=template&id=21cd1b86"
import script from "./DataTypesSection.vue?vue&type=script&lang=js"
export * from "./DataTypesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__